import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';
import queryString from 'query-string';

export interface Field {
  id: string;
  name: string;
}

export const getFields = async (signal?: AbortSignal): Promise<Field[]> => {
  const res = await apiClient.get<{ data: Field[] }>(`/filters/fields`, {
    signal,
    paramsSerializer: (prms) => queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return res.data.data;
};

interface UseFieldsOptions<TData> {
  config?: QueryConfig<typeof getFields, TData>;
}

export const useFilterFields = <TData = Field[]>({ config }: UseFieldsOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 120 * 1000,
    ...config,
    queryFn: ({ signal }) => getFields(signal),
    queryKey: ['filter-fields'],
  });
};
